import { IApplicationState } from '../../types/redux';

export const selectSearchShown = (state: IApplicationState) => state.config.searchShown;
